import axios from 'axios';

const TR = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'â': 'a', 'î': 'i', 'û': 'u' };

// Sunucudaki services/employee_search.fold ile aynı: Türkçe uyumlu, büyük/küçük harf ve aksan duyarsız
export const foldTr = (s) => (s || '')
  .replace(/İ/g, 'i').replace(/I/g, 'ı').toLowerCase()
  .replace(/[çğıöşüâîû]/g, (c) => TR[c])
  .normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

// RegExp kullanmadan güvenli vurgulama (özel karakterler sorun çıkarmaz)
export const highlightParts = (text, query) => {
  const src = String(text ?? '');
  const needle = foldTr(query);
  if (!query || query.length < 3 || !needle) return [src];
  let folded = '';
  const map = [];
  [...src].forEach((ch, i) => { const f = foldTr(ch); folded += f; for (let k = 0; k < f.length; k++) map.push(i); });
  const chars = [...src];
  const marks = new Array(chars.length).fill(false);
  for (let at = folded.indexOf(needle); at !== -1; at = folded.indexOf(needle, at + needle.length)) {
    for (let k = at; k < at + needle.length; k++) marks[map[k]] = true;
  }
  const parts = [];
  chars.forEach((ch, i) => {
    const last = parts[parts.length - 1];
    if (last && last.hit === marks[i]) last.text += ch; else parts.push({ text: ch, hit: marks[i] });
  });
  return parts.map((p) => (p.hit ? p : p.text));
};

// Yetkili tüm firmalar (mevcut /companies sayfalama + yetki kuralları, hafif yanıt)
export const fetchAllCompaniesBasic = async (api) => {
  const all = [];
  for (let page = 1; ; page++) {
    const { data } = await axios.get(`${api}/companies?fields=basic&page_size=500&page=${page}`);
    all.push(...(data.items || []));
    if (page >= (data.total_pages || 1)) return all;
  }
};
